import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import Headroom from "react-headroom"
import { NavToggle, Icon } from "@mostlycode/ui"
import Navigation from "components/Navigation"
import Responsive from "components/Responsive"

const StyledHeadroom = styled((props) => <Headroom {...props} />)`
  ${(props) =>
    props.header_style !== "stick"
      ? `
        margin-bottom: -8rem;
      `
      : `
        background: ${props.theme.colors.kelp};

  `}

  ${(props) => props.theme.media.tablet_landscape_up`
    ${props.header_style !== "stick" ? `margin-bottom: -12rem;` : ``}

  `}
`

const StyledNavToggle = styled(NavToggle)`
  border: none;
  background: transparent;
  transition: all ease-out 0.2s;
  color: ${(props) => props.theme.colors.ice};

  .headroom--pinned & {
    color: ${(props) => props.theme.colors.primary};
  }

  &:active {
    background: none;
  }

  &:focus {
    outline: none;
    background: none;
  }
`

const StyledHeader = styled.header`
  width: 100%;
  color: ${(props) => props.theme.colors.primary};
  background: ${(props) =>
    props.header_style === "sticky" ? props.theme.colors.kelp : "transparent"};
  transition: all ease-out 0.2s;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0.2);
  padding: 0 2rem;
  height: 8rem;

  .headroom--unfixed & {
  }

  .headroom--unpinned & {
  }

  .headroom--scrolled &,
  .headroom--pinned & {
    height: 8rem;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
    background: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.primary};
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    height: 12rem;
  `}
`

const StyledNav = styled.nav`
  display: flex;
`

const StyledHeaderInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  ${(props) => props.theme.media.tablet_landscape_up`
    width: 90%;
    margin: 0 auto;
    max-width: 120rem;
  `}
`

const StyledLogo = styled(Link)`
  display: block;
  flex: 0 1 20%;
  max-width: 10.7rem;

  svg {
    transition: all ease-out 0.2s;
    width: 6.7rem;
    height: 6.7rem;
    fill: ${(props) => props.theme.colors.ice};

    .headroom--scrolled &,
    .headroom--pinned & {
      width: 6.7rem;
      height: 6.7rem;
      fill: ${(props) => props.theme.colors.primary};
    }
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    svg {
      transition: all ease-out 0.2s;
      width: 8.7rem;
      height: 8.7rem;
      fill: ${(props) => props.theme.colors.ice};

      .headroom--scrolled &,
      .headroom--pinned & {
        width: 6.7rem;
        height: 6.7rem;
        fill: ${(props) => props.theme.colors.primary};
      }
    }
  `}
`

function Header({
  header_style,
  mainNavigation,
  onNavToggle,
  lang,
  children,
  ...props
}) {
  return (
    <StyledHeadroom header_style={header_style} style={{ zIndex: 1000 }}>
      <StyledHeader header_style={header_style}>
        <StyledHeaderInner>
          <StyledLogo to={lang === "en-gb" ? "/en" : "/"}>
            <Icon icon="logo" title="Mostly Code Logo" />
          </StyledLogo>
          <StyledNav>
            <Responsive
              phone={<StyledNavToggle onToggle={onNavToggle} />}
              tabletLandscape={
                <Navigation nav={mainNavigation} lang={lang} {...props} />
              }
            />
          </StyledNav>
        </StyledHeaderInner>
      </StyledHeader>
    </StyledHeadroom>
  )
}

export default Header
